import React from 'react';
import PropTypes from "prop-types";
import styles from "../Terms.module.scss";

const TermsTable = ({ children }) => {
    return (
        <div className={styles.tableContainer}>
            <div className={styles.tableScroll}>
                <table className="table table-striped table-bordered">
                    <tbody>{children}</tbody>
                </table>
            </div>
        </div>
    );
};

TermsTable.propTypes = {
    children: PropTypes.node,
}

export default TermsTable;
